import React, { useEffect, useState, useContext } from 'react';
import {
  createStyles,
  Grid,
  makeStyles,
  MenuItem,
  Select,
  Theme,
  Button,
  InputAdornment,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  InputLabel,
  Snackbar
} from '@material-ui/core';
import '../css/Login/Login.css';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';
import { parseJwt, parseParamToObject, validateToken } from '../utils/Cookie';
import { isDesktop } from 'react-device-detect';
import { IoMdBusiness } from "react-icons/io";
import FadeLoader from 'react-spinners/FadeLoader';
import SessionContext from '../Context/SessionContext';
import { Alert } from '@mui/material';

interface Params {
  email: string;
  name: string;
  logout: boolean;
  accessToken: string;
  expires: string;
  expiresIn: string;
  azureId: string;
  error: string;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      minHeight: '100vh',
    },
    spinner: {
      display: 'flex',
      justifyContent: 'center',
      marginTop: '10%',
      maxWidth: '150px'
    },
    divImage: {
      width: '65%',
      minHeight: '100vh',
      backgroundImage: 'url("/banner-espelho.jpg")',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
    },
    divImageCliente: {
      width: '65%',
      height: '100vh',
      backgroundImage: 'url("/banner-espelho.jpg")',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
    },
    divImageError: {
      width: '65%',
      height: '100vh',
      justifyContent: 'center',
      backgroundColor: theme.palette.primary.main,
      '& > img': {
        width: 'auto',
        height: '50%',
        maxHeight: '100vh'
      }
    },
    content: {
      display: 'flex',
      flexDirection: 'column',
      width: isDesktop ? '35%' : '100%',
      minHeight: '100vh',
      justifyContent: 'flex-start',
      paddingTop: '1vh',
      backgroundColor: 'white',
      fontFamily: 'Montserrat',
    },
    preview: {
      width: '100%',
      height: '100%'
    },
    boxTitle: {
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'column',
      marginTop: '4% !important',
    },
    boxForm: {
      display: 'flex',
      marginTop: '7px',
      justifyContent: 'center',
      '& > .titleForm': {
        flexDirection: 'column',
        '& > .MuiInputBase-root': {
          width: isDesktop ? '75%' : '75%',
          paddingLeft: '0 !important',
          borderRadius: '10px',
          marginTop: '10px',
          marginBottom: '10px'
        }
      }
    },
    spanBemVindo: {
      fontSize: '20px',
      color: '#757575',
      lineHeight: '24.38px'
    },
    spanTitleBemVindo: {
      fontSize: '24px',
      color: '#1A3661',
      fontWeight: 700,
      lineHeight: '30.01px'
    },
    boxAcesseConta: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      margin: '20px 0',
    },
    lineLeft: {
      flex: 1,
      height: '1px',
      backgroundColor: '#757575',
      margin: '0 10px 0 5vw',
    },
    lineRight: {
      flex: 1,
      height: '1px',
      backgroundColor: '#757575',
      margin: '0 5vw 0 10px',
    },
    spanAcesseConta: {
      color: 'black',
      fontWeight: 600,
      lineHeight: '24px',
      fontSize: '16px',
      textAlign: 'center',
      fontFamily: 'Montserrat',
    },
    spanSelecione: {
      color: theme.palette.primary.main,
      fontWeight: 500,
      fontSize: '14.75px',
      lineHeight: '17.98x'
    },
    spanProblemas: {
      fontWeight: 500,
      fontSize: '13px',
      lineHeight: '15.85px',
      marginTop: '5%',
      '& > a': {
        marginLeft: '5px',
        fontWeight: 700
      }
    },
    selectCompany: {
      textAlign: 'center',
      height: '34px',
      [theme.breakpoints.up('md')]: {
        height: '33px',
      },
      [theme.breakpoints.up('lg')]: {
        height: '34px',
      },
    },
    selectAdornment: {
      backgroundColor: '#c2c2c2',
      borderRadius: '10px 0 0 10px',
      padding: '1px 5px',
      justifyContent: 'center',
      height: '100%',
      display: 'flex',
      alignItems: 'center',
      minWidth: '40px',
      [theme.breakpoints.up('md')]: {
        padding: '1px 5px',
        justifyContent: 'center',
      },
      [theme.breakpoints.up('lg')]: {
        padding: '1px 5px',
        justifyContent: 'center',
      },
    },
    button: {
      marginTop: '2%',
      display: 'flex',
      flexDirection: 'column',
      '& > button': {
        backgroundColor: '#273564',
        borderRadius: '10px',
        color: 'white',
        fontWeight: 500,
        width: '26vw',
        height: '46px',
        fontSize: '12px !important',
        [theme.breakpoints.down('sm')]: {
          width: '76vw',
          height: '40px',
        },
        [theme.breakpoints.up('md')]: {
          height: '38px',
        },
        [theme.breakpoints.up('lg')]: {
          height: '46px',
        },
      },
      '& > button:hover': {
        backgroundColor: 'rgba(39, 53, 100, 0.7) !important',
      }
    },
    toggleButton: {
      borderRadius: '10px',
      height: '40px',
      minWidth: '120px',
      fontSize: '12px',
      fontWeight: 500,
      margin: '0 5px',
      backgroundColor: '#273564',
      color: 'white',
      opacity: 0.5,
      '&:hover': {
        backgroundColor: 'rgba(39, 53, 100, 0.7)',
      }
    },
    toggleButtonActive: {
      opacity: 1
    }
  })
)

const formatCnpj = (value: string) => {
  // Remove todos os caracteres não numéricos
  const cnpj = value.replace(/\D/g, '');

  // Aplica a máscara XX.XXX.XXX/XXXX-XX e limita o tamanho
  return cnpj
    .replace(/(\d{2})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1/$2')
    .replace(/(\d{4})(\d)/, '$1-$2')
    .slice(0, 18);
};

function ViewTest() {
  const classes = useStyles()

  const lastCodEmp = 1;
  const [empresa, setEmpresa] = useState(lastCodEmp);
  const [isErrorSession, setIsErrorSession] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation()
  const [messageSnack, setMessageSnack] = useState('');
  const [variantSnack, setVariantSnack] = useState('');
  const [openSnack, setOpenSnack] = useState(false);
  const [isLoadingUrl, setIsLoadingUrl] = useState(true);
  const [urlBackground, setUrlBackground] = useState('')
  const [isErrorUrlImage, setIsErrorImage] = useState(false);
  const { setSession } = useContext(SessionContext);
  const [loginType, setLoginType] = useState<'interno' | 'cliente'>('interno');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loadingCliente, setLoadingCliente] = useState(false);
  const [emailError, setEmailError] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [openRegisterModal, setOpenRegisterModal] = useState(false);
  const [registerCnpj, setRegisterCnpj] = useState('');
  const [registerNome, setRegisterNome] = useState('');
  const [registerEmail, setRegisterEmail] = useState('');
  const [registerPassword, setRegisterPassword] = useState('');
  const [registerErrors, setRegisterErrors] = useState({
    cnpj: '',
    email: '',
    password: '',
    nome: '',
    confirmPassword: ''
  });
  const [passwordValidation, setPasswordValidation] = useState({
    minLength: false,
    uppercase: false,
    lowercase: false,
    number: false,
    special: false,
  });
  const [registerConfirmPassword, setRegisterConfirmPassword] = useState('');
  const [openForgotModal, setOpenForgotModal] = useState(false)
  const [forgotEmail, setForgotEmail] = useState('')
  const [forgotEmailError, setForgotEmailError] = useState('')
  const [loadingForgotPassword, setLoadingForgotPassword] = useState(false)
  const [showResendEmailBtn, setShowResendEmailBtn] = useState(false);
  const [loadingResendEmail, setLoadingResendEmail] = useState(false);

  const resetRegisterModal = () => {
    setRegisterCnpj('');
    setRegisterNome('');
    setRegisterEmail('');
    setRegisterPassword('');
    setRegisterConfirmPassword('');

    setRegisterErrors({
      cnpj: '',
      nome: '',
      email: '',
      password: '',
      confirmPassword: ''
    });

    setPasswordValidation({
      minLength: false,
      uppercase: false,
      lowercase: false,
      number: false,
      special: false,
    });
  };

  const handleSearchClient = async (cnpj: string) => {
    try {
      if (!cnpj.trim()) return;

      const cleanedCnpj = cnpj.replace(/\D/g, '');

      const url = `${process.env.REACT_APP_BACKEND}/buscar-cliente-cnpj`;

      const { data } = await axios.get(url, {
        params: {
          cnpj: cleanedCnpj
        }
      });

      if (data?.cliente) {

        setRegisterNome(
          data.cliente.nomCli ||
          ''
        );

        setRegisterEmail(
          (data.cliente.emanfe || '').trim()
        );

        setRegisterErrors((prev) => ({
          ...prev,
          cnpj: '',
          nome: ''
        }));

        return;
      }

      // caso não encontre
      setRegisterNome('');
      setRegisterEmail('');
      setRegisterPassword('');

      setPasswordValidation({
        minLength: false,
        uppercase: false,
        lowercase: false,
        number: false,
        special: false,
      });

      setRegisterErrors((prev) => ({
        ...prev,
        nome: 'CNPJ não encontrado na base de clientes'
      }));

    } catch (error) {
      setRegisterNome('');
      setRegisterEmail('');
      setRegisterPassword('');

      setPasswordValidation({
        minLength: false,
        uppercase: false,
        lowercase: false,
        number: false,
        special: false,
      });

      setRegisterErrors((prev) => ({
        ...prev,
        nome: 'Erro ao localizar cliente pelo CNPJ'
      }));
    }
  };

  const validateRegister = () => {
    const errors = {
      cnpj: '',
      nome: '',
      email: '',
      password: '',
      confirmPassword: ''
    };

    let hasError = false;

    if (!registerCnpj.trim()) {
      errors.cnpj = 'Preencha o CNPJ';
      hasError = true;
    }

    if (!registerNome.trim()) {
      errors.nome = 'Cliente não localizado';
      hasError = true;
    }

    if (!registerEmail.trim()) {
      errors.email = 'Preencha o e-mail';
      hasError = true;
    } else {
      const emailRegex =
        /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const emails = registerEmail
        .split(/[;,]+/)
        .map((email) => email.trim().replace(/\\@/g, '@'))
        .filter(Boolean);

      if (!emails.length || emails.some((email) => !emailRegex.test(email))) {
        errors.email = 'Digite e-mails válidos separados por ponto e vírgula';
        hasError = true;
      }
    }

    if (!registerPassword.trim()) {
      errors.password = 'Preencha a senha';
      hasError = true;
    } else {
      const validation =
        validatePassword(registerPassword);

      const isPasswordValid =
        Object.values(validation).every(Boolean);

      if (!isPasswordValid) {
        errors.password =
          'A senha não atende os requisitos';
        hasError = true;
      }
    }

    if (registerPassword !== registerConfirmPassword) {
      errors.confirmPassword = 'As senhas não coincidem';
      hasError = true;
    }

    setRegisterErrors(errors);

    return !hasError;
  };

  const validatePassword = (password: string) => {
    const validations = {
      minLength: password.length >= 8,
      uppercase: /[A-Z]/.test(password),
      lowercase: /[a-z]/.test(password),
      number: /[0-9]/.test(password),
      special: /[^A-Za-z0-9]/.test(password),
    };

    return validations;
  };

  const handleSnackbar = (message: string, variant: string) => {
    setMessageSnack(message);
    setVariantSnack(variant);
    setOpenSnack(true);
  };

  const handleLogin = () => {
    const loginApi = process.env.REACT_APP_LOGIN_API;
    const frontUrl = process.env.REACT_APP_FRONT_URL;

    localStorage.setItem('empresa', String(empresa));
    localStorage.setItem('loginType', 'azure');
    window.location.href = `${loginApi}/signin?redirectTo=${frontUrl}/login`;
  };

  const handleLoginCliente = async () => {
    try {
      setLoadingCliente(true);

      setEmailError('');
      setPasswordError('');
      setShowResendEmailBtn(false);

      let hasError = false;

      if (!email.trim()) {
        setEmailError('Preencha o e-mail');
        hasError = true;
      }

      if (!password.trim()) {
        setPasswordError('Preencha a senha');
        hasError = true;
      }

      if (hasError) return;

      const url = `${process.env.REACT_APP_BACKEND}/login-cliente`;

      const { data } = await axios.post(url, {
        email,
        password
      });

      localStorage.setItem(
        'token',
        data.accessToken
      );

      localStorage.setItem(
        'refreshToken',
        data.refreshToken
      );

      localStorage.setItem(
        'empresa',
        String(empresa)
      );

      localStorage.setItem(
        'loginType',
        'cliente'
      );

      localStorage.setItem(
        'nmRep',
        data.user.nome || 'CLIENTE'
      );

      navigate('/');

    } catch (error: any) {

      const message =
        error?.response?.data?.message || '';

      if (message?.toLowerCase()?.includes('e-mail')) {
        setEmailError(message);
        if (message?.toLowerCase()?.includes('valide') || message?.toLowerCase()?.includes('validar') || message?.toLowerCase()?.includes('validado')) {
          setShowResendEmailBtn(true);
        }
      } else if (message?.toLowerCase().includes('senha')) {
        setPasswordError(message);
      } else {
        handleSnackbar(
          'Erro ao realizar login',
          'error'
        );
      }

    } finally {
      setLoadingCliente(false);
    }
  };

  const handleResendValidationEmail = async () => {
    try {
      setLoadingResendEmail(true);
      const url = `${process.env.REACT_APP_BACKEND}/reenviar-validacao`;
      const { data } = await axios.post(url, { email: email.trim() });
      handleSnackbar(data.message || 'E-mail de validação reenviado com sucesso!', 'success');
      setShowResendEmailBtn(false);
    } catch (error: any) {
      const message = error?.response?.data?.message || 'Erro ao reenviar e-mail de validação';
      handleSnackbar(message, 'error');
    } finally {
      setLoadingResendEmail(false);
    }
  };

  const handleLoginTypeChange = (type: 'interno' | 'cliente') => {
    setLoginType(type);
    // Limpa os estados dos formulários para evitar vazamento de estado entre os tipos de login
    setEmail('');
    setPassword('');
    setEmailError('');
    setPasswordError('');
    setShowResendEmailBtn(false);

    setOpenForgotModal(false);
    setForgotEmail('');
    setForgotEmailError('');

    setOpenRegisterModal(false);
    resetRegisterModal();
  };

  const handleForgotPassword = async () => {
    try {

      setForgotEmailError('')

      if (!forgotEmail.trim()) {
        setForgotEmailError('Preencha o e-mail')
        return
      }

      setLoadingForgotPassword(true)

      await axios.post(
        `${process.env.REACT_APP_BACKEND}/forgot-password-cliente`,
        {
          email: forgotEmail.trim()
        }
      )

      handleSnackbar(
        'Enviamos um link para redefinição de senha no seu e-mail.',
        'success'
      )

      setOpenForgotModal(false)
      setForgotEmail('')

    } catch (error: any) {
      const message =
        error?.response?.data?.message ||
        'Erro ao solicitar redefinição'

      setForgotEmailError(message)

    } finally {
      setLoadingForgotPassword(false)
    }
  }

  const registerLogin = async (
    name: string,
    email: string,
    expiresIn: string,
    accessToken: string,
    codEmp: string,
    azureId: string,
  ) => {
    try {
      setIsLoading(true);
      const credentials = {
        empresa,
        name,
        email,
        expiresIn,
        accessToken,
        azureId,
        codEmp
      };
      const url = `${process.env.REACT_APP_BACKEND}/registerLogin`;
      const { data } = await axios.post(url, credentials);

      localStorage.setItem('token', data.token);
      localStorage.setItem('empresa', String(empresa));
      localStorage.setItem('azureId', azureId);
      localStorage.setItem('categorias', JSON.stringify(data.categorias));
      localStorage.setItem('materiais', JSON.stringify(data.materiais));

      const parsedToken = parseJwt(data.token);

      if (parsedToken) {
        setSession(parsedToken);
      }

      navigate('/');
    } catch (error: any) {
      handleSnackbar(
        error?.response?.data.message || 'Ocorreu uma falha interna servidor.',
        'error',
      );
      localStorage.clear();
    } finally {
      setIsLoading(false);
    }
  };


  useEffect(() => {
    const setPhotoProfile = async (accessToken: string) => {
      try {
        const route = `${process.env.REACT_APP_SOCKET}/photo`
        const params = {
          headers: {
            authorization: `Bearer dNfPq5VXC4Mo8RWFqCxs`
          },
          params: {
            accessToken
          }
        }

        const { data } = await axios.get(route, params)
        const strBase64 = `data:image/png;base64,${data}`
        localStorage.setItem('profileBase64', strBase64)
      } catch (error: any) {
        console.log(error, 'error get photo profile')

      }
    }

    const initSystem = async () => {
      setIsErrorSession(false);
      if (validateToken()) {
        navigate('/');
        return;
      }
      const { search } = location;
      const params: Params = parseParamToObject(search) as unknown as Params;
      const {
        email,
        name,
        logout,
        accessToken,
        expires,
        expiresIn,
        azureId,
        error,
      } = params;

      if (error) {
        handleSnackbar(error, 'error');
        setIsErrorSession(true);
        return;
      }

      if (logout) {
        localStorage.clear();
        localStorage.setItem('empresa', String(lastCodEmp));
        localStorage.removeItem('token');
        localStorage.removeItem('accessToken');
        localStorage.removeItem('expiresToken');
        localStorage.removeItem('empresa');
        localStorage.removeItem('azureId');
        localStorage.removeItem('token')
        localStorage.removeItem('refreshToken')
        return;
      }

      if (accessToken && expires) {
        localStorage.setItem('accessToken', accessToken);
        localStorage.setItem('expiresToken', expires);
        localStorage.setItem('nmRep', name);
        await setPhotoProfile(accessToken)
        await registerLogin(
          name,
          email,
          expiresIn,
          accessToken,
          String(lastCodEmp),
          azureId,
        );
        return;
      }

      if (!validateToken()) {
        navigate('/login?logout=true');
      }
    };

    initSystem();
  }, []);

  return (
    <Grid container alignItems='center' className={classes.root}>
      {isDesktop && (loginType === 'cliente' ? (
        <Grid className={classes.divImageCliente} />
      ) : (
        <Grid className={classes.divImage} />
      ))}
      <Grid
        className={classes.content}
        style={{
          justifyContent: loginType === 'cliente' ? 'flex-start' : 'center',
          paddingTop: loginType === 'cliente' ? '0px' : '0px'
        }}
      >
        <Grid className={classes.boxTitle}>
          <span className={classes.spanTitleBemVindo}>Geradora</span>
        </Grid>
        <Grid container alignItems='flex-start' className={classes.boxForm}>
          <Grid container>
            <img
              src={process.env.PUBLIC_URL + '/TODOS-LOGOS.png'}
              alt={'imagem com as marcas da rojemac'}
              style={{ margin: '20px auto', width: '40%' }}
            />
          </Grid>
          <Grid container justifyContent="center" style={{ marginTop: 20 }}>
            <Button
              onClick={() => handleLoginTypeChange('interno')}
              className={`${classes.toggleButton} ${loginType === 'interno' ? classes.toggleButtonActive : ''
                }`}
            >
              Interno
            </Button>

            <Button
              onClick={() => handleLoginTypeChange('cliente')}
              className={`${classes.toggleButton} ${loginType === 'cliente' ? classes.toggleButtonActive : ''
                }`}
            >
              Cliente
            </Button>
          </Grid>
          <Grid container className={classes.boxAcesseConta}>
            <div className={classes.lineLeft}></div>
            <span className={classes.spanAcesseConta}>Acesse sua conta</span>
            <div className={classes.lineRight}></div>
          </Grid>
          <Grid container alignItems='center' className='titleForm'>
            <Select
              className={classes.selectCompany}
              value={empresa}
              variant='outlined'
              style={{ pointerEvents: 'none' }}
              onChange={(e) => {
                setEmpresa(Number(e.target.value))
                localStorage.setItem('last_cod_emp', String(e.target.value))
              }}
              startAdornment={
                <InputAdornment position='start'
                  className={classes.selectAdornment}
                >
                  <IoMdBusiness size={25} />
                </InputAdornment>
              }
              IconComponent={() => null}
            >
              <MenuItem key={'empresa-1'} value={1}>
                ROJEMAC
              </MenuItem>
            </Select>
          </Grid>
          {loginType === 'cliente' && (
            <div style={{ width: '100%' }} key="cliente-form-wrapper">
              <input
                type="email"
                placeholder="E-mail"
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value.trimStart());
                  setEmailError('');
                }}
                style={{
                  width: '70%',
                  margin: '6px auto 2px auto',
                  padding: '10px 12px',
                  textIndent: 0,
                  borderRadius: '10px',
                  border: emailError
                    ? '1px solid #d32f2f'
                    : '1px solid #ccc',
                  display: 'block',
                  outline: 'none'
                }}
              />

              {emailError && (
                <span
                  style={{
                    width: '70%',
                    margin: '0 auto',
                    color: '#d32f2f',
                    fontSize: '12px',
                    display: 'block',
                  }}
                >
                  {emailError}
                </span>
              )}
              {showResendEmailBtn && (
                <div style={{ width: '70%', margin: '5px auto', textAlign: 'left' }}>
                  <Button
                    variant="text"
                    size="small"
                    onClick={handleResendValidationEmail}
                    disabled={loadingResendEmail}
                    style={{
                      color: '#1A3661',
                      padding: 0,
                      textTransform: 'none',
                      fontSize: '12px',
                      fontWeight: 600
                    }}
                  >
                    {loadingResendEmail ? 'Enviando...' : 'Reenviar e-mail de verificação'}
                  </Button>
                </div>
              )}

              <input
                type="password"
                placeholder="Senha"
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                  setPasswordError('');
                }}
                style={{
                  width: '70%',
                  margin: '6px auto 2px auto',
                  padding: '10px 12px',
                  textIndent: 0,
                  borderRadius: '10px',
                  border: passwordError
                    ? '1px solid #d32f2f'
                    : '1px solid #ccc',
                  display: 'block',
                  outline: 'none'
                }}
              />

              {passwordError && (
                <span
                  style={{
                    width: '70%',
                    margin: '0 auto',
                    color: '#d32f2f',
                    fontSize: '12px',
                    display: 'block',
                  }}
                >
                  {passwordError}
                </span>
              )}

              <span style={{
                width: '70%',
                margin: '0 auto',
                fontSize: '12px',
                display: 'block',
                textAlign: 'right',
              }}>
                <a
                  href=''
                  target='_blank'
                  onClick={(e) => {
                    e.preventDefault()
                    setOpenForgotModal(true)
                  }}
                >
                  Esqueci minha senha
                </a>
              </span>
            </div>
          )}
          <Grid className={classes.button}>
            {loginType === 'interno' ? (
              <Button
                variant='contained'
                onClick={handleLogin}
                startIcon={
                  <img
                    src={process.env.PUBLIC_URL + '/microsoft.png'}
                    alt="Microsoft Logo"
                    style={{ width: '20px', height: '20px', marginRight: '8px' }}
                  />
                }
              >
                Entre com Microsoft
              </Button>
            ) : (
              <Button
                variant='contained'
                onClick={handleLoginCliente}
              >
                Entrar como Cliente
              </Button>
            )}
          </Grid>
          <Grid style={{ justifyItems: 'center' }}>
            {isLoading && (
              <Grid container alignItems='center' className={classes.spinner}>
                <FadeLoader color='#1A3661' />
              </Grid>
            )}
            <Grid style={{ margin: '10% auto 0px auto' }}>
              {loginType === 'interno' ? (
                <span className={classes.spanProblemas}>
                  Problemas com login?
                  <a
                    href='https://portalcsc.rojemac.com.br/index.php?noAUTO=1'
                    target='_blank'
                  >
                    Clique aqui
                  </a>
                </span>
              ) : (
                <span className={classes.spanProblemas}>
                  Não possui conta?
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      setOpenRegisterModal(true);
                    }}
                  >
                    Clique aqui
                  </a>
                </span>
              )}

              <Dialog
                open={openRegisterModal}
                onClose={() => {
                  setOpenRegisterModal(false);
                  resetRegisterModal();
                }}
                maxWidth="md"
                fullWidth
              >
                <DialogTitle style={{ backgroundColor: '#1A3661', color: '#fff' }}>
                  Cadastro de Cliente
                </DialogTitle>

                <DialogContent>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      gap: 16,
                      marginTop: 10
                    }}
                  >
                    <div>
                      <InputLabel>CNPJ</InputLabel>

                      <TextField
                        fullWidth
                        variant="outlined"
                        placeholder="Digite o CNPJ"
                        error={!!registerErrors.cnpj}
                        helperText={registerErrors.cnpj}
                        value={registerCnpj}
                        onChange={(e) => {
                          const formattedValue = formatCnpj(e.target.value);
                          setRegisterCnpj(formattedValue);

                          setRegisterErrors((prev) => ({
                            ...prev,
                            cnpj: '',
                            nome: ''
                          }));

                          // limpa os dados anteriores
                          setRegisterNome('');
                          setRegisterEmail('');
                          setRegisterPassword('');

                          setPasswordValidation({
                            minLength: false,
                            uppercase: false,
                            lowercase: false,
                            number: false,
                            special: false,
                          });

                          handleSearchClient(formattedValue);
                        }}
                      />
                    </div>

                    <div>
                      <InputLabel>Nome Fantasia</InputLabel>

                      <TextField
                        fullWidth
                        variant="outlined"
                        value={registerNome}
                        disabled
                        error={!!registerErrors.nome}
                        helperText={registerErrors.nome}
                      />
                    </div>

                    <div>
                      <InputLabel>E-mail</InputLabel>

                      <TextField
                        fullWidth
                        variant="outlined"
                        placeholder="Digite o e-mail"
                        error={!!registerErrors.email}
                        helperText={registerErrors.email}
                        value={registerEmail}
                        onChange={(e) => {
                          setRegisterEmail(
                            e.target.value.trimStart()
                          );

                          setRegisterErrors((prev) => ({
                            ...prev,
                            email: ''
                          }));
                        }}
                      />
                    </div>

                    <div>
                      <InputLabel>Senha</InputLabel>

                      <div
                        style={{
                          display: 'flex',
                          gap: 10
                        }}
                      >
                        <TextField
                          fullWidth
                          variant="outlined"
                          placeholder="Senha segura"
                          type="password"
                          error={!!registerErrors.password}
                          value={registerPassword}
                          onChange={(e) => {
                            const value = e.target.value;

                            setRegisterPassword(value);

                            setPasswordValidation(
                              validatePassword(value)
                            );

                            setRegisterErrors((prev) => ({
                              ...prev,
                              password: ''
                            }));
                          }}
                        />
                      </div>
                    </div>

                    <div>
                      <InputLabel>Confirmar Senha</InputLabel>

                      <TextField
                        fullWidth
                        variant="outlined"
                        placeholder="Digite novamente a senha"
                        type="password"
                        error={!!registerErrors.confirmPassword}
                        helperText={registerErrors.confirmPassword}
                        value={registerConfirmPassword}
                        onChange={(e) => {
                          setRegisterConfirmPassword(e.target.value);

                          setRegisterErrors((prev) => ({
                            ...prev,
                            confirmPassword: ''
                          }));
                        }}
                      />
                    </div>

                    <div
                      style={{
                        marginTop: 10,
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 4
                      }}
                    >
                      <span
                        style={{
                          fontSize: 12,
                          color: passwordValidation.minLength
                            ? '#2e7d32'
                            : '#d32f2f'
                        }}
                      >
                        • Mínimo de 8 caracteres
                      </span>

                      <span
                        style={{
                          fontSize: 12,
                          color: passwordValidation.uppercase
                            ? '#2e7d32'
                            : '#d32f2f'
                        }}
                      >
                        • Pelo menos 1 letra maiúscula
                      </span>

                      <span
                        style={{
                          fontSize: 12,
                          color: passwordValidation.lowercase
                            ? '#2e7d32'
                            : '#d32f2f'
                        }}
                      >
                        • Pelo menos 1 letra minúscula
                      </span>

                      <span
                        style={{
                          fontSize: 12,
                          color: passwordValidation.number
                            ? '#2e7d32'
                            : '#d32f2f'
                        }}
                      >
                        • Pelo menos 1 número
                      </span>

                      <span
                        style={{
                          fontSize: 12,
                          color: passwordValidation.special
                            ? '#2e7d32'
                            : '#d32f2f'
                        }}
                      >
                        • Pelo menos 1 caractere especial
                      </span>
                    </div>
                  </div>
                </DialogContent>

                <DialogActions style={{ padding: 20 }}>
                  <Button
                    onClick={() => {
                      setOpenRegisterModal(false);
                      resetRegisterModal();
                    }}
                  >
                    Cancelar
                  </Button>

                  <Button
                    variant="contained"
                    style={{
                      backgroundColor: '#1A3661',
                      color: '#fff'
                    }}
                    onClick={async () => {

                      const isValid = validateRegister();

                      if (!isValid) return;

                      try {

                        const { data } = await axios.post(
                          `${process.env.REACT_APP_BACKEND}/register-cliente`,
                          {
                            cnpj: registerCnpj,
                            nome: registerNome,
                            email: registerEmail.trim(),
                            password: registerPassword
                          }
                        )

                        const emailsEnviados = data.emailsEnviados || [];
                        const emailsComFalha = data.emailsComFalha || [];
                        const detalhesEnvio = [
                          emailsEnviados.length
                            ? `Token enviado para: ${emailsEnviados.join(', ')}.`
                            : '',
                          emailsComFalha.length
                            ? `Não foi possível enviar para: ${emailsComFalha.join(', ')}.`
                            : ''
                        ].filter(Boolean).join(' ');

                        handleSnackbar(
                          `${data.message || 'Cadastro realizado.'} ${detalhesEnvio}`.trim(),
                          emailsComFalha.length ? 'warning' : 'success'
                        )

                        resetRegisterModal()
                        setOpenRegisterModal(false)

                      } catch (error: any) {

                        const message =
                          error?.response?.data?.message ||
                          'Erro ao cadastrar cliente';

                        setRegisterErrors((prev) => ({
                          ...prev,
                          email: message.includes('E-mail')
                            ? message
                            : prev.email
                        }));

                        handleSnackbar(message, 'error');
                      }
                    }}
                  >
                    Cadastrar
                  </Button>
                </DialogActions>
              </Dialog>
              <Dialog
                open={openForgotModal}
                onClose={() => {
                  setOpenForgotModal(false)
                  setForgotEmail('')
                  setForgotEmailError('')
                }}
                maxWidth="sm"
                fullWidth
              >
                <DialogTitle
                  style={{
                    backgroundColor: '#1A3661',
                    color: '#fff'
                  }}
                >
                  Recuperar Senha
                </DialogTitle>

                <DialogContent>
                  <div
                    style={{
                      marginTop: 20,
                      display: 'flex',
                      flexDirection: 'column',
                      gap: 16
                    }}
                  >
                    <span
                      style={{
                        fontSize: 14,
                        color: '#555'
                      }}
                    >
                      Digite seu e-mail para receber o link de redefinição de senha.
                    </span>

                    <TextField
                      fullWidth
                      variant="outlined"
                      label="E-mail"
                      value={forgotEmail}
                      error={!!forgotEmailError}
                      helperText={forgotEmailError}
                      onChange={(e) => {
                        setForgotEmail(
                          e.target.value.trimStart()
                        )

                        setForgotEmailError('')
                      }}
                    />
                  </div>
                </DialogContent>

                <DialogActions style={{ padding: 20 }}>
                  <Button
                    onClick={() => {
                      setOpenForgotModal(false)
                      setForgotEmail('')
                      setForgotEmailError('')
                    }}
                  >
                    Cancelar
                  </Button>

                  <Button
                    variant="contained"
                    disabled={loadingForgotPassword}
                    onClick={handleForgotPassword}
                    style={{
                      backgroundColor: '#1A3661',
                      color: '#fff'
                    }}
                  >
                    {loadingForgotPassword
                      ? 'Enviando...'
                      : 'Enviar link'}
                  </Button>
                </DialogActions>
              </Dialog>
              <Snackbar
                open={openSnack}
                autoHideDuration={5000}
                onClose={() => setOpenSnack(false)}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right'
                }}
              >
                <Alert
                  onClose={() => setOpenSnack(false)}
                  severity={variantSnack as any}
                  variant="filled"
                >
                  {messageSnack}
                </Alert>
              </Snackbar>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default ViewTest;
